module.exports = __webpack_public_path__ + "static/media/Icon 2.9c969393.png";